import React, { useState } from 'react'
import { Button } from '@mui/material'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'

export const SaveAsPdfButton: React.FC = () => {
  const [isPrinting, setIsPrinting] = useState(false)

  const handleSaveAsPdf = () => {
    setIsPrinting(true)

    // Force light mode for PDF by temporarily adding a class
    document.documentElement.setAttribute('data-print-mode', 'true')

    // Small delay to ensure styles are applied
    setTimeout(() => {
      window.print()

      // Remove the print mode after printing dialog closes
      setTimeout(() => {
        document.documentElement.removeAttribute('data-print-mode')
        setIsPrinting(false)
      }, 100)
    }, 100)
  }

  return (
    <Button
      variant="outlined"
      size="small"
      startIcon={<PictureAsPdfIcon />}
      onClick={handleSaveAsPdf}
      disabled={isPrinting}
    >
      {isPrinting ? 'Preparing...' : 'Save as PDF'}
    </Button>
  )
}
